<template>
  <!-- v-if="canViewVerticalNavMenuLink(item)" OJOOO AQUI se vel los temas de los permisos -->
  <li
    class="nav-item"
    :class="[
      item.class,
      {
        'active': isActive,
        'disabled': item.disabled,
      }]"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <dynamic-svg v-if="item.svg" :svgTitle="item.title"/>
      <feather-icon v-if="!item.svg" :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-wrap-menu"  :id="item.title ? item.title : ''">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        :variant="item.tag.variant || 'light'"
        pill
        class="mr-1 ml-auto text-uppercase"
        :class="`label-${item.tag || 'beta'}`"
      >
        {{ item.tag.label }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import DynamicSvg from '@/views/components/custom/dinamyc-svg/DynamicSvg.vue'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
    DynamicSvg
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t
    }
  }

}
</script>
